import React from 'react';

function Errors() {
  return <div>Errors</div>;
}

export default Errors;
